import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import FilterListIcon from '@material-ui/icons/FilterList';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ActionText from '../../core/ActionText';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';
import QuickFilter from './QuickFilter';
import ResourceDisplay from './ResourceDisplay';
import AccessibleTooltip from '../../core/AccessibleTooltip';

const MAX_ITEMS = 1000;

class SearchResults extends Component {

  render() {

    const { classes, graph, resources, defaultLang, viewLang, project, columns, handleSelectionChange, baseLink, projectType,
      addFilter, excludeFilterProperties, ontologyProjectAssociation, onAddQuickFilter, classSelector, rowDisplay, resourceIn,
      components, viewOptions, editMode, onSelectRow, selectedRows, onSelectAll, allowFilters, graphInfo, componentLinkedProjectsMap,
      helpOnNoResults } = this.props;

    const notSelected = resources ? resources.filter(c => !selectedRows.includes(c)).length : 0;

    return (
      <div data-test="search-results">
        <div style={{
          width: '100%'
        }}>
          <TableContainer style={{
            overflowX: "initial"
          }}>
            <Table stickyHeader data-test="search-results-viewer">
              <TableHead data-test="results-header">
                <TableRow>
                  {editMode &&
                    <TableCell data-test={"header-edit-mode"} component="th" className={classes.tableHeadingPlain}>
                    </TableCell>
                  }
                  {
                    [...viewOptions, { label: "(View) In" }].map((col, index) => {
                      if (!col.heading && (!columns || index >= columns.length || columns[index])) {
                        return <TableCell
                          data-test={"header-" + col.label}
                          key={index}
                          component="th"
                          className={classes.tableHeadingPlain}>
                          <span>
                            {col.label}
                          </span>
                        </TableCell>;
                      }
                      else return null;
                    })
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                  {editMode &&
                    <TableCell data-test={"header-edit-mode"} component="th" className={classes.tableHeadingPlain}>
                      <span style={{ marginLeft: 4 }}>
                        <Tooltip title="Select all on this page">
                          <span>
                            <IconButton
                              aria-label="Select all"
                              disabled={notSelected === 0 || !resources || selectedRows.length > MAX_ITEMS - notSelected}
                              data-test="select-all"
                              className={classes.smallIconButton}
                              size="small"
                              onClick={() => onSelectAll(resources)}>
                              <SelectAllIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </span>
                    </TableCell>
                  }
                  {
                    [...viewOptions, { label: "(View) In" }].map((col, index) => {
                      if (!col.heading && (!columns || index >= columns.length || columns[index])) {
                        return <TableCell
                          data-test={"header-" + col.label}
                          key={index}
                          component="th"
                          className={classes.tableHeadingPlain}>
                          {col.canFilter && allowFilters &&
                            <div style={{ display: 'flex', justifyContent: col.quickFilter ? 'flex-start' : 'flex-end' }}>
                              {col.quickFilter &&
                                <div>
                                  {col.format === "class" ?
                                    classSelector
                                    :
                                    <QuickFilter
                                      lang={viewLang}
                                      label={col.label}
                                      dataTest={"filter-input-" + index}
                                      onAddFilter={onAddQuickFilter}
                                      property={col.value}
                                      exclude={[]} />
                                  }
                                </div>
                              }
                              {(col.format !== "class" || classSelector) &&
                                <div data-test={"add-filter-" + index} style={{ marginLeft: 4, marginTop: 2 }}>
                                  <AccessibleTooltip title="Add a filter">
                                    <span>
                                      <IconButton
                                        aria-label="Add filter"
                                        data-test="add-filter"
                                        disabled={excludeFilterProperties.includes(col.value)}
                                        className={classes.smallIconButton}
                                        size="small"
                                        onClick={() => addFilter(col)}>
                                        <FilterListIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </AccessibleTooltip>
                                </div>
                              }
                            </div>
                          }
                        </TableCell>;
                      }
                      else return null;
                    })
                  }
                </TableRow>
              </TableBody>
              <TableBody data-test="results-body">
                {resources && resources.map((resource) => <ResourceDisplay
                  suppressLoading={true}
                  editMode={editMode}
                  baseLink={baseLink}
                  innerDisplay={rowDisplay}
                  canSelect={selectedRows.length < MAX_ITEMS}
                  selected={selectedRows.includes(resource)}
                  ontologyProjectAssociation={ontologyProjectAssociation}
                  onSelectRow={onSelectRow}
                  viewOptions={viewOptions}
                  display={columns}
                  resourceIn={resourceIn}
                  graphInfo={graphInfo}
                  overrideMediaType={true}
                  componentLinkedProjectsMap={componentLinkedProjectsMap}
                  key={resource}
                  components={components}
                  handleSelectionChange={handleSelectionChange}
                  project={project}
                  projectType={projectType}
                  viewLang={viewLang}
                  defaultLang={defaultLang}
                  id={resource}
                  graph={graph} />)}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {(!resources || resources.length === 0) &&
          <div style={{ clear: 'both', minHeight: '80px' }}>
            {helpOnNoResults ?
              <ActionText dataTest="add-filters" offset="120px">Add filters to search.</ActionText>
              :
              <ActionText dataTest="no-results" offset="70px" format="result">No results.</ActionText>
            }
          </div>
        }
      </div>
    );
  }

}

SearchResults.defaultProps = {
  excludeFilterProperties: [],
  ontologyProjectAssociation: [],
  helpOnNoResults: false
};

SearchResults.propTypes = {
  classes: PropTypes.object,
  resource: PropTypes.array,
  classSelector: PropTypes.object,
  allowFilters: PropTypes.bool,
  helpOnNoResults: PropTypes.bool,
  rowDisplay: PropTypes.object.isRequired,
  onSelectAll: PropTypes.func,
  addFilter: PropTypes.func,
  columns: PropTypes.array,
  excludeFilterProperties: PropTypes.array,
  onAddQuickFilter: PropTypes.func,
  onSelectRow: PropTypes.func,
  baseLink: PropTypes.string.isRequired,
  selectedRows: PropTypes.array,
  ontologyProjectAssociation: PropTypes.array,
  onPageSizeChange: PropTypes.func,
  handleSelectionChange: PropTypes.func,
  viewOptions: PropTypes.array.isRequired,
  project: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string.isRequired,
  components: PropTypes.array.isRequired,
  graphInfo: PropTypes.object,
  componentLinkedProjectsMap: PropTypes.object,
  resourceIn: PropTypes.string,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(SearchResults);